module.exports = __webpack_public_path__ + "img/AX.53197b0d.svg";